
import React from 'react'
import { IUserInfo } from '../../../Store/User/Types'
import { I18N } from '../../../Store/I18n/Types'

export const getConfirmModalContent = (envelopeStatus: string, isValidated: boolean, userInfo: IUserInfo, i18n: I18N) => {
    if (envelopeStatus === 'completed') {
        return {
            title: i18n._('Envoie à la sacem'),
            content: (
                <div>
                    <p>{i18n._('Votre document signé électroniquement a été envoyé à la Sacem.')}</p>
                    <p>{i18n._("L'équipe d'Adtrack vous remercie pour votre collaboration.")}</p>
                </div>
            )
        }
    }

    if (envelopeStatus === 'sent') {
        return {
            title: i18n._('Resend Electronic signature'),
            content: (
                <div>
                    <p>{i18n._('Le document vous a été renvoyé en signature électronique.')}</p>
                    <p>{i18n._("L'équipe d'Adtrack vous remercie pour votre collaboration.")}</p>
                </div>
            )
        }
    }

    if (isValidated) {
        return {
            title: i18n._('Electronic signature'),
            content: (
                <div>
                    <p>{i18n._('Your declaration has been sent to our partner Docusign for electronic signature.')}</p>
                    <p>{i18n._('You will receive an email in order to sign your document.')}</p>
                    <p>{i18n._("L'équipe d'Adtrack vous remercie pour votre collaboration.")}</p>
                </div>
            )
        }
    }

    return {
        title: i18n._('Sauvegarde'),
        content: (
            <div>
                <p>{i18n._('Les modifications ont été sauvegardées.')}</p>
                <p>{i18n._("L'équipe d'Adtrack vous remercie pour votre collaboration.")}</p>
            </div>
        )
    }
}

export const userFormIdentity = (userInfo: IUserInfo, i18n: I18N) => {
    return (
        <>
            <b>Procédure de signature électronique</b>
            <br />
            <br />
            En cliquant sur confirmer, vous déclenchez la procédure de signature
            électronique via Docusign.
            <br />
            Vous allez recevoir un mail de la part de Docusign vous invitant à
            signer le document avec ces informations :
            <br />
            <br />
            {i18n._('First name')} : {userInfo.firstname}
            <br />
            {i18n._('Last name')} : {userInfo.name}
            <br />
            {i18n._('Email')} : {userInfo.email}
            <br />
            {i18n._('Société')} : {userInfo.parent_info.name}
            <br />
            <br />
            Une fois rendu sur Docusign et terminé de signer, votre document vous
            sera envoyé par mail et vous pourrez revenir sur Adtrack pour l'envoyer à
            la Sacem
        </>
    )
}

